import { React, useState, useEffect } from "react";
import LHBase from "../lh-base/lh-base";
import { getGlobalStore } from "@cisco/spaces-dash-lib-redux-store";
import { Provider } from "react-redux";
import "./App.css";

const defaultParams = {
  id: "business-hierarchy",
  type: "single",
  requiredLicenses: [
    "unlimited",
    "act",
    "smart_ops",
    "smart_venues",
    "extend",
    "see",
  ],
  enableSearch: true,
  isPopup: false,
  isReportsLocation: false,
  isDataId: false,
  appData: {},
  restrictedLocations: [],
  appName: "business-hierarchy",
  dummyTree: false,
};

const LocationTree = (props) => {
  // const [params, setParams] = useState(defaultParams);

  // // useEffect(() => {
  // //   console.log("treeProps", props);
  // //   if (props.params) {
  // //     setParams(props.params);
  // //   }
  // //   console.log("Location Hierarchy App Mount");

  // //   return () => {
  // //     console.log("Location Hierarchy App Destroy");
  // //   };
  // // }, []);
  return (
    props.params &&
    Object.keys(props.params).length > 0 && (
      <div>
        <Provider store={getGlobalStore()}>
          {props.callback ? (
            <LHBase callback={props.callback} props={props.params}></LHBase>
          ) : (
            <LHBase props={props.params}></LHBase>
          )}
        </Provider>
      </div>
    )
  );
};

export default LocationTree;
